'use strict';

import util from '../util';
import pdfUtils from '../pdfUtils';
import ajax from '../ajax';
import modalExport from '../modal';
const modal = modalExport.global;
import validator from '../validator';
import googleAddressAutocomplete from './checkout/googleAddressAutocomplete';
import tooltip from '../tooltip';
import processstates from './processstates';
import checkoutAddress from './checkout/address';
import inputField from '../input-field';
import toasts from '../toast-notify';

let addressType;

//Creating instance of PDFDocument Class using HTMLtoPDF library - npm package
const initOrderHistory = function() {
    const $invoiceLinks = $('a.download-invoice');
    $invoiceLinks.on('click', downloadInvoice);
    $('a.prepaid-dhl-label').on('click', downloadPrepaidLabel);
    $('.js-update-order-address').on('click keydown', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            updateOrderAddress.call(this, event);
        }
    });
    modal.$cntr.off('submit.orderAddress keydown', '.js-order-edit-address')
        .on('submit.orderAddress keydown', '.js-order-edit-address', function(event) {
            if (event.type === 'submit' || (event.type === 'keydown' && event.key === 'Enter')) {
                saveOrderAddress.call(this, event);
            }
        });
    modal.$cntr.off('keydown.orderAddressPhoneScroll', '.js-order-edit-address')
        .on('keydown.orderAddressPhoneScroll', '.js-order-edit-address', function(event) {
            if (event.key !== 'Tab') {
                return;
            }

            setTimeout(function() {
                if (!$(document.activeElement).is('.js-order-edit-address input[type="tel"]')) {
                    return;
                }

                const modalBody = modal.$cntr.find('.modal-body')[0];
                $(modalBody).stop(true).animate({ scrollTop: modalBody.scrollHeight }, 300);
            }, 0);
        });

    //Disabling Right Click on Download Invoice Link
    $invoiceLinks.on('contextmenu',function(e){
        return false;
    });

    //No self service returns overlay displayed
    $('.createReturn a').on('click', function(e) {
        if($(this).attr('href').indexOf('noselfreturn') >= 0) {
            e.preventDefault();
            const popup = new Foundation.Reveal($('#order-no-self-return'));
            //Window height minus 80px, which sets the modal to fit inside the device's screen
            const windowHeight = window.innerHeight - 130;
            popup.$element.children('.modal-body').css('max-height', windowHeight);	
            popup.open();
        }
    });

    $('body').on('change keydown', '#order-edit-sameasshipping', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        if ($(this).is(':checked')) {
            $('.order-address-linked-notice').removeClass('hide'); 
            scrollToTopOfModal()
        } else {
            $('.order-address-linked-notice').addClass('hide');
        }
    });
}

function scrollToTopOfModal() {
     $('#address-dialog-wrapper').get(0).scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function updateOrderAddress(event) {
    event.preventDefault();
    const $button = $(this);
    const $status = $button.siblings('.order-address-update-status');
    const previousActiveElement = document.activeElement;
    const readAddressData = function (field) {
        return $button.attr('data-' + field) || '';
    };

    addressType = $button.attr('data-address-type') === 'shipping' ? 'shipping' : 'billing';

    const address = {
        AddressLine1: readAddressData('address-line1'),
        AddressLine2: readAddressData('address-line2'),
        AddressLine3: readAddressData('address-line3'),
        City: readAddressData('city'),
        Country: readAddressData('country'),
        FirstName: readAddressData('first-name'),
        LastName: readAddressData('last-name'),
        State: readAddressData('state'),
        ZipCode: readAddressData('zip-code'),
        EMailID: readAddressData('email'),
        MobilePhone: readAddressData('mobile-phone'),
        addressType: readAddressData('address-type')
    };

    const personnal = {
        FirstName: address.FirstName,
        LastName: address.LastName,
        EMailID: address.EMailID,
        MobilePhone: address.MobilePhone
    };

    $status.text('');
    $.ajax({
        url: $button.attr('data-edit-url'),
        type: 'POST',
        dataType: 'html',
        data: {
            address: JSON.stringify(address),
            personnal: JSON.stringify(personnal)
        }
    }).done(function (response) {
        modal.addCustomClass('order-edit-address modal-reveal-new');
        modal.$cntr.attr('aria-labelledby', 'order-address-dialog-heading');
        modal.$cntr.attr('aria-describedby', 'order-address-dialog-description');
        modal.events.onOpen(function () {
            accessibility.setKeepFocusInside(modal.$cntr[0], true);
            setTimeout(function () {
                modal.$cntr.find('.close-button').trigger('focus');
            }, 1000);
        });
        modal.events.onClose(function () {
            if (document.body.contains(previousActiveElement)) {
                previousActiveElement.focus();
            }
            accessibility.setKeepFocusInside(modal.$cntr[0], false);
            modal.$cntr.find('.modal-body').empty();
        });
        modal.renderContent(response);
        $('.order-edit-address').find('.form-row').each(function() {
            $(this).addClass('no-material-input');
            if($(this).hasClass('email-hidden')) {
                $(this).removeClass('email-hidden');
            }
        });
        
        const $form = $('form[id$="EditAddressForm"]');
        $form.find('.same-as-shipping').toggle(
            $form.find('input[name="addressType"]').val() !== 'billing' || $('.shipping-edit').is(':visible')
        );
        validator.initForm('form[id$="EditAddressForm"]');
        processstates.refreshStates($form);
        const savedCountry = $('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country');
        const $countrySelect = $('select[name$="_country"]');
        $countrySelect.val(savedCountry);
        const countryCode = util.getCallingCountryCode(savedCountry);
        const phoneFiled = $form.find('input[name$="_phone"]');
        phoneFiled.attr('data-country-code', countryCode);
        util.handleCountryCodeUpdate(phoneFiled);
        tooltip.init();
        checkoutAddress.init();
        googleAddressAutocomplete.init();
        inputField.setEditMaterialFields();
        
         setTimeout(() => {
                util.limitCharacters();
            }, 2500);

    }).fail(function () {
        $status.text($button.attr('data-error-message'));
    }).always(function () {
        $button.prop('disabled', false);
    });
}

function saveOrderAddress(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const $form = $(this);
    if ($form.data('saving')) {
        return;
    }
    if (!this.checkValidity()) {
        this.reportValidity();
        return;
    }

    const $formFields = $form.find(':input');
    const readField = function (field) {
        return $formFields.filter('[name$="_' + field + '"]').val() || '';
    };
    let addressType = $form.find('[name="addressType"]').val();
    const sameAsShipping = $formFields.filter('[name="sameasshipping"]').is(':checked');
    if (sameAsShipping && addressType === 'billing') {
        addressType = 'shipping';
    }
    const address = {
        AddressLine1: readField('address1'),
        AddressLine2: readField('address2'),
        AddressLine3: readField('address3') || $form.find('[name="AddressLine3"]').val() || '',
        City: readField('city'),
        Country: readField('country'),
        FirstName: readField('firstName'),
        LastName: readField('lastName'),
        State: readField('state') || $form.find('[name="State"]').val() || '',
        ZipCode: readField('postal'),
        EMailID: readField('emailAddress'),
        MobilePhone: readField('phoneNumber'),
        addressType: addressType
    };
    const $save = $form.find('[type="submit"]');
    const $status = $form.find('.js-order-address-save-status');
    $form.data('saving', true);
    $save.text($save.attr('data-saving-text'));
    $save.prop('disabled', true);
    $status.text('');

    $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        dataType: 'json',
        data: {
            addresses: JSON.stringify(address),
            sameasshipping: sameAsShipping
        }
    }).done(function (response) {
       if (response && response.success) {
            modal.close();
            toasts.init($('.js-update-order-address[data-address-type="' + addressType + '"]').attr('data-success-message'), 'active order-address-update-success animate__fadeInDownToast', 'icon-close');
            setTimeout(function () {
                window.location.reload();
            }, 4000);
        } else {
            const isContact = response && response.scenario === 'CONTACT';
            const errorMessage = $form.attr(isContact ? 'data-error-message-orderinprogress' : 'data-error-message');
            $save.prop('disabled', true);
            $save.text($save.attr('data-close-text')).on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
            $('<div class="order-address-error" role="alert"><p class="order-address-error-message">' + errorMessage + '</p>	</div>').insertAfter($('.order-address-linked-notice'));
            scrollToTopOfModal();
            modal.events.onClose(function () {
                window.location.reload();
            });
            if (!isContact) {
                $status.text(errorMessage);
            }
        }
    }).fail(function () {
        $status.text($form.attr('data-error-message'));
    }).always(function () {
        $form.data('saving', false);
        $save.prop('disabled', false);
    });
}


function downloadPrepaidLabel(e) {
    e.preventDefault();
    var pdfEncodedData = $(this).data('pdf-encoded');
    var $this = $(this);
    var filename = $(this).attr('download');
    $(this).attr('disabled', 'disabled');
	
    if(pdfEncodedData == '') {
        var that = this;
        var perpaidURL = $(this).data('prepaid-url');

        ajax.getJson({
            url : perpaidURL,
            callback: function(response) {
                if (!response || response.outputImage == '') {
                    if(response.msg) {
                        $('.return-summary-block .printPrepaidLabel-error').text(response.msg);
                    } else {
                        window.alert('Couldn\'t download prepaid label');
                    }
                    $(that).removeAttr('disabled');		
	                $this.removeAttr('disabled');
                    return false;
                }
                pdfEncodedData = response.outputImage;
                getPrepaidLabelPDF(pdfEncodedData, filename, that);
				
                $(that).data('pdf-encoded', pdfEncodedData);
            }
        });
    } else {
        getPrepaidLabelPDF(pdfEncodedData, filename, this);
    }
}

function getPrepaidLabelPDF(pdfEncodedData, filename, clickEle) {
    var blob = getBlob(pdfEncodedData);
	
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
	
    $(clickEle).removeAttr('disabled');
}

function getBlob(base64Data){
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: 'application/pdf;charset=utf-8'});
}


function downloadInvoice(e) {
    e.preventDefault();

    var invoiceURL = $(this).attr('href');

    $.ajax({
        url : invoiceURL,
        type : 'GET'
    }).then(function(response){
        var doc = new jsPDF('l', 'pt', 'a4');
        var invoiceNumber = $(response).find('#invoice-number-pdf');
        var invoiceAddress = $(response).find('#invoice-address-pdf');
        var orderNumber = $(response).find('#page-intro-pdf');
        var orderDate = $(response).find('#order-date-pdf');
        var invoiceDate = $(response).find('#invoice-date-pdf');
        var invoiceEmeaTaxNumber = $(response).find('#invoice-emea-tax-number-pdf');
        var invoiceSubsidiaryInformation = $(response).find('#invoice-subsidiary-information-pdf address');
        var cardImageEle = $(response).find('.payment-block .logo').get(0);
        var pdfcardImageBase64 = getBase64Image(cardImageEle);
        var idInfo = $(response).find('.id-documents');
		
        //Order Table Data Push
        var orderTableColumn = new Array();
        $(response).find('.address-method-payment-table-column').each(function() {
            orderTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
        });
        orderTableColumn.push('');
		
        var orderTableRows = new Array();
        var orderTableRow = new Array();
        var i = 0;
        $(response).find('.address-method-payment-table-row').each(function() {
            if(cardImageEle != null && i == 3) {
                orderTableRow.push('');
            }
            orderTableRow.push($(this).text().trim());
            i++;
        });

        orderTableRows.push(orderTableRow);
		
        //Product Table Data Push
        var productTableColumn = new Array();
        $(response).find('.table-header span').each(function() {
            productTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
        });

        var productTableRows = new Array();

        $(response).find('.table-rows').each(function() {
            var productTableRow = new Array();
			
            $(this).find('span').each(function() {
                productTableRow.push($(this).text().trim().replace(/\s+/g, ' '));
            });
			
            productTableRows.push(productTableRow);
        });

        //Order Total Data Push
        var orderTotalsColumns = ['', ''];
        var orderTotalsRows = new Array();
		
        $(response).find('.calculations-container div.clearfix').each(function() {
            var orderTotalsRow = new Array();
            var line1 = $(this).find('.order-label-pdf').text().trim().replace(/\s+/g, ' ');
            var line2 = $(this).find('.order-value-pdf').text().trim().replace(/\s+/g, ' ');
			
            orderTotalsRow.push(line1);
            orderTotalsRow.push(line2);
			
            orderTotalsRows.push(orderTotalsRow);
        });

        var narsLogoEle = $(response).find('.pdf-nars-logo').get(0);
        var imgData = getBase64Image(narsLogoEle);
        var pdfInvoiceNumberText = pdfUtils.getElementHtmlTrim(invoiceNumber);
        var pdfInvoiceAddressText = pdfUtils.getElementHtmlTrim(invoiceAddress);
        var pdfOrderNumberText = pdfUtils.getElementHtmlTrim(orderNumber);
        var pdfOrderDateText = pdfUtils.getElementHtmlTrim(orderDate);
        var pdfInvoiceDateText = pdfUtils.getElementHtmlTrim(invoiceDate);
        var pdfInvoiceEmeaTaxNumber = pdfUtils.getElementHtmlTrim(invoiceEmeaTaxNumber);
        var pdfInvoiceSubsidiaryInformation = pdfUtils.getElementHtmlTrim(invoiceSubsidiaryInformation);
        var idDocuments = pdfUtils.getElementHtmlTrim(idInfo);
		
        //emea tax invoice info
        var emeaTaxCol = [''],
            taxInfo1 = [invoiceEmeaTaxNumber.text().trim().replace(/\s+/g, ' ')],
            taxInfo2 = [invoiceSubsidiaryInformation.html().trim().replace(/\s+/g, ' ')],
            subSidiaryStr = invoiceSubsidiaryInformation.html().split('<br>'),
            emeaTaxRows	= [];
        $.each(subSidiaryStr, function(index, value){
            var subSidiaryAdd = [];
            subSidiaryAdd.push(value.replace(/\s+/g, ' '));
            emeaTaxRows.push(subSidiaryAdd);
        })
		
        generateInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
            pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
            pdfInvoiceSubsidiaryInformation, orderTableColumn, orderTableRows, productTableColumn, productTableRows, 
            orderTotalsColumns, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments);
    });
}

function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
}

function generateInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
    pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
    pdfInvoiceSubsidiaryInformation, orderTableColumn, orderTableRows, productTableColumn, productTableRows, 
    orderTotalsColumns, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments) {

    doc.page=1;
    //Logo and Invoice Number
    doc.addImage(imgData, 'PNG', 18, 20, 150, 75);
    doc.fromHTML(pdfInvoiceNumberText, 20, 100);
    doc.fromHTML(idDocuments, 180, 75);

    //Invoice Address
    var addHtml = $.parseHTML(pdfInvoiceAddressText)[0].innerHTML,
        addLeftPos = 620, 
        htmlArray = addHtml.split('<br>');
	
    $.each(htmlArray, function(i, j){
        if(j.length > 35)
            addLeftPos = 490;
    })
    doc.fromHTML(pdfInvoiceAddressText, addLeftPos, 20, {'width': 425});

    //Payment Text, Image and Value
    doc.addImage(pdfcardImageBase64, 'PNG', 475, 185, 48.75, 30.75);

    //Order Number, Order Date, Invoice Date
    doc.fromHTML(pdfOrderNumberText, 25, 285);
    doc.fromHTML(pdfOrderDateText, 195, 285);
    doc.fromHTML(pdfInvoiceDateText, 350, 285);

    //Table - Product, Unit Price, Quantity, Total Price
    doc.autoTable(orderTableColumn, orderTableRows, {theme: 'plain',
        styles:{cellPadding: 5, overflow: 'linebreak'},
        columnStyles: {
            0: {columnWidth: 150},
            1: {columnWidth: 150},
            2: {columnWidth: 150},
            3: {columnWidth: 60},
            4: {columnWidth: 150}
        },
        startY: false,
        margin: {top: 155, left: 20}
    });

    //Order Total table
    doc.autoTable(orderTotalsColumns, orderTotalsRows, {theme: 'plain', 
        columnStyles:{
            0: {columnWidth: 150, halign: 'left'},
            1: {columnWidth: 50, halign: 'right'}
        },
        styles:{columnWidth: 150, overflow: 'linebreak'}, 
        margin: {top: 325, left: 630},
        createdCell: function(cell, data) {
            if (data.row.index === 3) { 
                cell.styles.fontStyle = 'bold';
            }
        }
    });

    var totalPages = 1;

    if(productTableRows.length > 6) {
        totalPages = 2;
    }

    doc.setFontSize(8);
    doc.text(400, 580, Resources.INVOICE_PAGE + doc.page + ' '+ Resources.INVOICE_OF +' '+  totalPages);
    doc.page ++;

    //Product list table
    doc.autoTable(productTableColumn, productTableRows, {theme: 'striped', 
        columnStyles: {
            0: {columnWidth: 230, halign:'left'},
            1: {columnWidth: 74},
            2: {columnWidth: 74},
            3: {columnWidth: 74},
            4: {columnWidth: 55},
            5: {columnWidth: 75}
        },
        styles:{
            halign: 'center',
            overflow: 'linebreak'
        },
        headerStyles:{
            halign: 'left',
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255]
        },
        startY: 350,
        margin: {top: 20, left: 20, bottom: 80}
    });

    if(productTableRows.length > 6) {
        doc.text(400, 580, Resources.INVOICE_PAGE + doc.page + ' '+ Resources.INVOICE_OF +' '+ totalPages);
    }

    //EMEA Tax Number, Name, Group Address
    //	doc.autoTable.previous.finalY;
    //	doc.fromHTML(pdfInvoiceEmeaTaxNumber, 630, 550);
    //	doc.fromHTML(pdfInvoiceSubsidiaryInformation, 630, 580);
	
    //EMEA Tax Number, Name, Group Address table
	
    doc.autoTable(emeaTaxCol, emeaTaxRows, {theme: 'plain', 
        columnStyles: {
            0: {halign: 'center'}
        },
        tableWidth: 'auto',
        showHeader: '',
        headerStyles: {
            halign: 'center'
        },
        styles:{
            overflow: 'linebreak',
            cellPadding: 1,
            fontSize: 10
        },
        startY: 528,
        margin: {top: 30, left: 20}
    });
	
	
    //pdf generation and file creation
    doc.save(Resources.DOWNLOAD_INVOICE_FILENAME);
}

export default {
    init: function () {
        initOrderHistory();
    }
};
